import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import rolesGrammyJson from '../data/roles_grammy.json';
import rolesLatinGrammyJson from '../data/roles_latingrammy.json';
import config from '../config';
import ProcessingOverlay from './ProcessingOverlay';

class Step3 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.parentState.certificate.id, 
            name: this.props.parentState.certificate.name,
            email: this.props.parentState.certificate.email,
            phone: this.props.parentState.certificate.phone,
            company: this.props.parentState.certificate.company,
            address1: this.props.parentState.certificate.address1,
            address2: this.props.parentState.certificate.address2,
            address3: this.props.parentState.certificate.address3,
            addressUnitNumber: this.props.parentState.certificate.addressUnitNumber,
            city: this.props.parentState.certificate.city,
            stateProvinceID: this.props.parentState.certificate.stateProvinceID,
            postalCode: this.props.parentState.certificate.postalCode,
            countryID: this.props.parentState.certificate.countryID,
            numberOfCertificates: this.props.parentState.certificate.numberOfCertificates,
            totalCost: this.props.parentState.certificate.totalCost,
            participationDescription: this.props.parentState.certificate.participationDescription,
            participationNotes: this.props.parentState.certificate.participationNotes,
            certificateHash: this.props.parentState.certificate.certificateHash,
            uploadedFileName: this.props.parentState.certificate.uploadedFileName || "",
            originalFileName: this.props.parentState.certificate.originalFileName || "",
            selectedFile: this.props.parentState.certificate.selectedFile,
            selectedFileError: "",
            nameOnCertificate: this.props.parentState.certificate.nameOnCertificate,
            certificateRoles: [],
            isProcessing: false,
            previousStep: false,
            payByCreditCard: false,
            payByCheck: false,

            countryArray: [],
            stateArray: [],
            academyID: config.environment.application.academyID,
            errorMessage: "",
            validationErrors: [],
            serverErrorFields: []
        }

        this.handleChange = this.handleChange.bind(this);

    }
    
    updateParentState() {
        this.props.parentState.certificate.id = this.state.id;
        this.props.parentState.certificate.name = this.state.name;
        this.props.parentState.certificate.email = this.state.email;
        this.props.parentState.certificate.phone = this.state.phone;
        this.props.parentState.certificate.company = this.state.company;
        this.props.parentState.certificate.address1 = this.state.address1;
        this.props.parentState.certificate.address2 = this.state.address2;
        this.props.parentState.certificate.address3 = this.state.address3;
        this.props.parentState.certificate.addressUnitNumber = this.state.addressUnitNumber;
        this.props.parentState.certificate.city = this.state.city;
        this.props.parentState.certificate.stateProvinceID = this.state.stateProvinceID;
        this.props.parentState.certificate.postalCode = this.state.postalCode;
        this.props.parentState.certificate.countryID = this.state.countryID;
        this.props.parentState.certificate.numberOfCertificates = this.state.numberOfCertificates;
        this.props.parentState.certificate.totalCost = this.state.totalCost;
        this.props.parentState.certificate.participationDescription = this.state.participationDescription;
        this.props.parentState.certificate.participationNotes = this.state.participationNotes;
        this.props.parentState.certificate.selectedFile = this.state.selectedFile;
        this.props.parentState.certificate.certificateHash = this.state.certificateHash;
        this.props.parentState.certificate.uploadedFileName = this.state.uploadedFileName;
        this.props.parentState.certificate.originalFileName = this.state.originalFileName;
        this.props.parentState.certificate.nameOnCertificate = this.state.nameOnCertificate;
        this.props.parentState.certificate.academyID = this.state.academyID;
    }

    async componentDidMount() {
        let roles_json = "";
        if (config.environment.application.academyID === 1) {
            roles_json = rolesGrammyJson.map(current_role => { return {value: current_role.name, display: current_role.name} });
        }
        if (config.environment.application.academyID === 2) {
            roles_json = rolesLatinGrammyJson.map(current_role => { return {value: current_role.name, display: current_role.name} });
        }
        this.setState({ certificateRoles: [{value: '', display: 'Please select your role...'}].concat(roles_json) });

        let country_data = await import('../data/countries.json');
        this.setState({countryArray: country_data.default.map(current_object => { return current_object })});

        let state_data = await import('../data/states.json');
        this.setState({stateArray: state_data.default.map(current_object => { return current_object })});

    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });

        switch (event.target.name) {
            case "numberOfCertificates":
                this.setState({totalCost: event.target.value * config.environment.application.certificatePrice});
                break;
            case "countryID":
                this.setState({stateProvinceID: ""});
                break;
            default:
                break;
        }
    }
   
    isFieldValid(field_name) {
        var is_valid = false;

        switch (field_name) {
            case "name":
                is_valid = (this.state.name !== "");
                break;
            case "nameOnCertificate":
                is_valid = (this.state.nameOnCertificate !== "");
                break;
            case "email":
                //https://www.regular-expressions.info/email.html
                is_valid = (this.state.email !== "" && (/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(this.state.email)));
                break;
            case "phone":
                is_valid = (this.state.phone !== "");
                break;
            case "address1":
                is_valid = (this.state.address1 !== "");
                break;
            case "city":
                is_valid = (this.state.city !== "");
                break;
            case "stateProvince":
                is_valid = 
                    (this.state.stateProvinceID !== undefined && this.state.stateProvinceID !== "") || 
                    (
                        (this.state.countryID !== undefined && this.state.countryID !== "") &&
                        (this.statesForCountry().length === 0)
                    )
                     
                ; 
                break;
            case "postalCode":
                is_valid = (this.state.postalCode !== "");
                break;
            case "country":
                is_valid = (this.state.countryID !== undefined && this.state.countryID !== "");
                break;
            case "numberOfCertificates":
                is_valid = (this.state.numberOfCertificates > 0);
                break;
            case "participationDescription":
                is_valid = (this.state.participationDescription !== "");
                break;
            case "selectedFile":
                is_valid = (this.state.selectedFile !== null);
                break;
            default:
                console.log(field_name + " was not found");
        }

        return is_valid;
    }

    // Returns true if the server's last validation response flagged this form field, so we can show the
    // same red border used for client-side validation. Maps the UI field id to the normalized (lowercase)
    // server property key captured in validateCertificateInfo().
    fieldHasServerError(field_name) {
        const map = {
            name: "name",
            nameOnCertificate: "nameoncertificate",
            email: "email",
            phone: "phone",
            address1: "address1",
            addressUnitNumber: "addressunitnumber",
            city: "city",
            stateProvince: "stateprovinceid",
            postalCode: "postalcode",
            country: "countryid",
            numberOfCertificates: "numberofcertificates",
            participationDescription: "participationdescription",
            company: "company",
            participationNotes: "participationnotes"
        };
        const key = map[field_name];
        return key !== undefined && this.state.serverErrorFields.indexOf(key) !== -1;
    }

    isFormValid() {
        var is_form_valid = (
            this.isFieldValid("name") && 
            this.isFieldValid("nameOnCertificate") && 
            this.isFieldValid("email") &&
            this.isFieldValid("phone") &&
            this.isFieldValid("address1") &&
            this.isFieldValid("city") &&
            this.isFieldValid("stateProvince") &&
            this.isFieldValid("postalCode") &&
            this.isFieldValid("country") &&
            this.isFieldValid("numberOfCertificates") && 
            this.isFieldValid("participationDescription") &&
            this.isFieldValid("selectedFile")
        );

        return is_form_valid;
    }

    statesForCountry() {
        let state_array = [];
        var country_id = parseInt(this.state.countryID);

        if (this.state.stateArray.length > 0) {
            for (var x = 0; x < this.state.stateArray.length; x++) {
                var temp_state = this.state.stateArray[x];

                if (temp_state.countryID === country_id)
                    state_array.push(temp_state);
            }
        }

        return state_array;
    }

    chooseFile = (e) => {
        window.document.getElementById("choose-file").click();
    }

    fileUploadHandler = (event) => {
        let selected_file = event.target.files[0];
        this.setState({ selectedFileError: "" });

        if (selected_file === undefined) {
            //They clicked cancel.  Let's do nothing here.
        }
        else if (selected_file.size > config.MAX_ATTACHMENT_SIZE)
        {
            //File too large!
            event.target.value = "";
            this.setState({ selectedFile: null });
            this.setState({ selectedFileError: "The maximum file size is 25MB" });
        }
        else if (!/(\.pdf|\.doc|\.docx|\.jpg|\.gif|\.png)$/i.test(selected_file.name)) {
            //Bad file extension.
            event.target.value = "";
            this.setState({ selectedFile: null });
            this.setState({ selectedFileError: "Valid file types are: PDF, DOC, DOCX, JPG, GIF, PNG" });
		}
        else {
            //It's a good size and file extension.
            this.setState({ selectedFile: selected_file });
        }
    }

    previousStep = (e) => {
        e.preventDefault();
        this.updateParentState();
        this.setState({previousStep: true});
    }

    makePaymentByCheck = (e) => {
        e.preventDefault();
        this.updateParentState();

        this.validateCertificateInfo().then((valid) => {
            if (!valid) return;
            this.saveCertificateToDatabase().then((response) => {
                if (response) {
                    this.props.parentState.paymentMethod = "check";
                    this.setState({payByCheck: true});
                }
            });
        });
    }

    makePaymentByCreditCard = (e) => {
        e.preventDefault();
        this.updateParentState();

        this.validateCertificateInfo().then((valid) => {
            if (!valid) return;
            this.saveCertificateToDatabase().then((response) => {
                if (response) {
                    this.props.parentState.paymentMethod = "credit_card";
                    this.setState({payByCreditCard: true});
                }
            });
        });
    }

    // Server-side validation of the Step 3 certificate/contact fields, using the same DataAnnotations
    // the payment endpoint enforces. Blocks advancing to payment until the form is valid, and surfaces
    // any errors here in Step 3. Returns true if valid, false otherwise.
    async validateCertificateInfo() {
        this.setState({ isProcessing: true, errorMessage: "", validationErrors: [], serverErrorFields: [] });
        let is_valid = true;
        const url = config.environment.application.baseUrl + "/api/certificate/validate";
        const cert = this.props.parentState.certificate;

        const certInfo = {
            name: cert.name,
            email: cert.email,
            phone: cert.phone,
            address1: cert.address1,
            addressUnitNumber: cert.addressUnitNumber,
            city: cert.city,
            // Send null (not "") so a country with no states validates — mirrors the payment request.
            stateProvinceId: cert.stateProvinceID || null,
            postalCode: cert.postalCode,
            countryId: cert.countryID,
            numberOfCertificates: cert.numberOfCertificates,
            historyId: cert.historyID,
            participationDescription: cert.participationDescription,
            participationNotes: cert.participationNotes,
            nameOnCertificate: cert.nameOnCertificate,
            academyId: cert.academyID,
            company: cert.company
        };

        await fetch(url, {
            method: 'POST',
            headers: new Headers({
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(certInfo)
        })
        .then(async (response) => {
            if (!response.ok) {
                const data = await response.json();
                const errors = (data && data.errors) ? data.errors : {};
                const messages = Object.keys(errors).length > 0
                    ? Object.values(errors).flat()
                    : ["Please review your information and try again."];
                // Normalize the server's field keys (e.g. "Email", "$.email") to lowercase so we can
                // map them back to the form fields and highlight them with a red border.
                const fieldKeys = Object.keys(errors).map(k => k.split('.').pop().toLowerCase());
                this.setState({ validationErrors: messages, serverErrorFields: fieldKeys, isProcessing: false });
                is_valid = false;
            }
            // On success, leave isProcessing true — saveCertificateToDatabase continues the overlay.
        })
        .catch((error) => {
            console.log(error);
            this.setState({ errorMessage: "We couldn't validate your information. Please try again.", isProcessing: false });
            is_valid = false;
        });

        return is_valid;
    }

    async saveCertificateToDatabase() {
        this.setState({isProcessing: true, errorMessage: ""});
        let return_value = true;
        const url = config.environment.application.baseUrl + "/api/certificate/uploadFile";

        const data = new FormData();
        data.append('file', this.state.selectedFile);
        data.append('existingToken', this.state.certificateHash || '');

        await fetch(url, {
            method: 'POST',
            body: data
        })
        .then(async response => {
            if (!response.ok) {
                const errorData = await response.json();
                this.setState({ errorMessage: errorData.title });
                return_value = false;
            } else {
                const { token, storedFileName, originalFileName } = await response.json();
                this.setState({ id: token, certificateHash: token, uploadedFileName: storedFileName, originalFileName });
                this.props.parentState.certificate.id = token;
                this.props.parentState.certificate.certificateHash = token;
                this.props.parentState.certificate.uploadedFileName = storedFileName;
                this.props.parentState.certificate.originalFileName = originalFileName;
            }
        })
        .catch((error) => {
            console.log(error);
            this.setState({ errorMessage: "File upload failed. Please try again." });
            return_value = false;
        });

        this.setState({isProcessing: false});

        return return_value;
    }

    render() {

        // Catch previous orders
        if (this.props.parentState.transactionID && this.props.parentState.transactionID !== "") {
            this.props.parentState.transactionID = "";
            this.props.parentState.certificate.id = 0;
            this.props.parentState.certificate.numberOfCertificates = 0;
            this.props.parentState.certificate.totalCost = 0;
            this.props.parentState.certificate.participationDescription ="";
            this.props.parentState.certificate.participationNotes = "";
            this.props.parentState.certificate.selectedFile = null;
            return (<Redirect push to='/step2'/>);
        }

        if (this.state.previousStep || this.props.parentState.selectedHistoryItem === "")
            return (<Redirect push to='/step2' />);

        if (this.state.payByCheck)
            return (<Redirect push to='/thankyou' />);

        if (this.state.payByCreditCard) 
            return (<Redirect push to='/payment' />);

        return (
            <div>
                <ProcessingOverlay isProcessing={this.state.isProcessing} />  
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12">
                        <h1>Contact Information</h1>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4">
                        <b>Name</b><br />
                        <input type="text" maxLength="100" className={"form-control " + ((!this.isFieldValid("name") || this.fieldHasServerError("name")) ? "validationError" : "")} name="name" value={this.state.name} onChange={this.handleChange} />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-4">
                        <b>Email</b><br />
                        <input type="text" maxLength="100" className={"form-control " + ((!this.isFieldValid("email") || this.fieldHasServerError("email")) ? "validationError" : "")} name="email" value={this.state.email} onChange={this.handleChange} />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-4">
                        <b>Phone</b><br />
                        <input type="text" maxLength="30" className={"form-control " + ((!this.isFieldValid("phone") || this.fieldHasServerError("phone")) ? "validationError" : "")} name="phone" value={this.state.phone} onChange={this.handleChange} />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12">
                        <b>Company or C/O (if applicable)</b><br />
                        <input type="text" maxLength="200" className={"form-control " + (this.fieldHasServerError("company") ? "validationError" : "")} name="company" value={this.state.company} onChange={this.handleChange}  />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-8">
                        <b>Street Address</b><br />
                        <input type="text" maxLength="200" className={"form-control " + ((!this.isFieldValid("address1") || this.fieldHasServerError("address1")) ? "validationError" : "")} name="address1" value={this.state.address1} onChange={this.handleChange}  />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4">
                        <b>Apartment, Unit, or Suite Number</b><br />
                        <input type="text" maxLength="50" className={"form-control " + (this.fieldHasServerError("addressUnitNumber") ? "validationError" : "")} name="addressUnitNumber" value={this.state.addressUnitNumber} onChange={this.handleChange}  />
                    </div>
                    {/* <div className="col-xs-12 col-sm-12">
                        <b>Address 2</b><br />
                        <input type="text" className="form-control" name="address2" value={this.state.address2} onChange={this.handleChange}  />
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <b>Address 3</b><br />
                        <input type="text" className="form-control" name="address3" value={this.state.address3} onChange={this.handleChange}  />
                    </div> */}
                    <div className="col-xs-12 col-sm-12">
                        <b>Country</b><br />
                        <select name="countryID" value={this.state.countryID} onChange={this.handleChange} className={"form-control " + ((!this.isFieldValid("country") || this.fieldHasServerError("country")) ? "validationError" : "")}>
                            <option value="">Select Country...</option>
                            {
                                this.state.countryArray.map((current_object) => {
                                    return <option key={`country_${current_object.id}`} value={current_object.id}>{current_object.name}</option>
                                })
                            }
                        </select>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-5">
                        <b>City</b><br />
                        <input type="text" maxLength="50" className={"form-control " + ((!this.isFieldValid("city") || this.fieldHasServerError("city")) ? "validationError" : "")} name="city" value={this.state.city} onChange={this.handleChange}  />
                    </div>
                    <div className="col-xs-12 col-sm-8 col-md-4">
                        <b>State/Province</b><br />
                        <select name="stateProvinceID" value={this.state.stateProvinceID} onChange={this.handleChange} className={"form-control " + ((!this.isFieldValid("stateProvince") || this.fieldHasServerError("stateProvince")) ? "validationError" : "")}>
                            <option value="">Select State/Province...</option>
                            {
                                this.statesForCountry().map((current_object) => {
                                    return <option key={`state_${current_object.id}`} value={current_object.id}>{current_object.name}</option>
                                })
                            }
                        </select>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-3">
                        <b>Postal Code</b><br />
                        <input type="text" maxLength="30" className={"form-control " + ((!this.isFieldValid("postalCode") || this.fieldHasServerError("postalCode")) ? "validationError" : "")} name="postalCode" value={this.state.postalCode} onChange={this.handleChange}  />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12">
                        <br />
                        <br />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12">
                        <h1>Certificate Information</h1>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4">
                        <b>Name (as it will appear on certificate)</b><br />
                        <input type="text" maxLength="250" className={"form-control " + ((!this.isFieldValid("nameOnCertificate") || this.fieldHasServerError("nameOnCertificate")) ? "validationError" : "")} name="nameOnCertificate" value={this.state.nameOnCertificate} onChange={this.handleChange} />
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <b>Please select role on this project</b> (the Recording Academy reserves the right to determine whether or not it is an eligible participation)
                        <select name="participationDescription" value={this.state.participationDescription} onChange={this.handleChange} className={"form-control " + ((this.state.participationDescription === "" || this.fieldHasServerError("participationDescription")) ? "validationError" : "")}>
                            {this.state.certificateRoles.map((certificate_role) => <option key={certificate_role.value} value={certificate_role.value}>{certificate_role.display}</option>)}
                        </select>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12">
                        <b>Notes to support your role - optional (500 character limit)</b><br />
                        <textarea className={"form-control " + (this.fieldHasServerError("participationNotes") ? "validationError" : "")} name="participationNotes" value={this.state.participationNotes} onChange={this.handleChange} maxLength="500" />
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <br />
                        <b>Upload pdf, scan, or clear photo of Liner Notes or Professional Service Crediting Role</b><br />
                        <input style={{display: "none"}} id="choose-file" type="file" onChange={this.fileUploadHandler} />
                        <input type="button" className={"btn " + (this.state.selectedFile === null ? "btn-danger" : "btn-secondary")} value="Browse for Files" onClick={this.chooseFile} />&nbsp;&nbsp;
                        <span><b>Selected file: </b>{(this.state.selectedFile === null) ? "" : this.state.selectedFile.name}</span><span style={{color: "red"}}>{this.state.selectedFileError}</span><br />
                        <br />
                        {this.state.errorMessage && (
                            <div className="alert alert-danger">{this.state.errorMessage}</div>
                        )}
                        Valid file types are: PDF, DOC, DOCX, JPG, GIF, PNG<br />
                        Maximum file size is 25MB.<br />
                        <br />
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <b>Number of Copies (${config.environment.application.certificatePrice}/each):</b><br />
                        <input type="number" min="0" className={"form-control " + ((!this.isFieldValid("numberOfCertificates") || this.fieldHasServerError("numberOfCertificates")) ? "validationError" : "")} style={{width: "100px"}} name="numberOfCertificates" value={this.state.numberOfCertificates} onChange={this.handleChange}  />
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        &nbsp;
                    </div>

                    {this.state.validationErrors && this.state.validationErrors.length > 0 && (
                        <div className="col-xs-12 col-sm-12">
                            <div className="alert alert-danger">
                                <b>Please correct the following before continuing:</b>
                                <ul style={{marginBottom: 0}}>
                                    {this.state.validationErrors.map((msg, i) => <li key={`ve_${i}`}>{msg}</li>)}
                                </ul>
                            </div>
                        </div>
                    )}

                    <div className="col-xs-12 col-sm-6">
                        <button className="btn btn-primary" disabled={this.state.isProcessing} onClick={this.previousStep} style={{width: "100%"}}>Previous Page</button><br />
                        <br />
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <button className="btn btn-primary" disabled={!this.isFormValid() || this.state.isProcessing} onClick={this.makePaymentByCreditCard} style={{width: "100%"}}>Pay now by Credit Card</button><br />
                        <br />
                    </div>
                </div>
            </div>
        );
    }
}
/*
                <div className="col-xs-12 col-sm-4">
                    <button className="btn btn-primary" disabled={!this.isFormValid() || this.state.isProcessing} onClick={this.makePaymentByCheck} style={{width: "100%"}}>Mail a Check</button><br />
                    <br />
                </div>

*/

export default Step3;